import React from 'react';
import { motion } from 'framer-motion';

export const TrustFooter: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.8 }}
        className="text-center"
      >
        <p className="text-xs sm:text-sm text-luxury-text-muted dark:text-white/60">
          <span className="text-luxury-gold font-semibold">SPV-structured.</span>
          {' '}Fully transparent.{' '}
          <span className="text-luxury-gold font-semibold">Your capital and ours, aligned.</span>
        </p>
      </motion.div>
    </section>
  );
};

export default TrustFooter;
